import { createStore } from "vuex";

const store = createStore({
  state: {
    user: {},

    statusNavbar: false,
    ModalCancel: {
      rrimEdit: false,
      rrimView: false,
      layout_extracao: false,
      itemChecklist: false,
    },
    DataImages: {
      AberturaEmbalagem: {},
      MoldeFechado: {},
      MoldeAberto: {},
    },
    DataImagesLSP: [],
    ImgURL: `${process.env.VITE_API_RRIM}/static/`,
    DataAllRRIM: {},
    emitData: {
      produtos: [],
      checklist: [],
    },
    listLayout: [],
    listItems: [],
    loading: false,
    loadingPattern: false,
    loadingPatternProgress: {
      status: false,
      progress: 0,
      total: 0,
      loading: 0,
    },
  },

  mutations: {
    MutationImagesAberturaEmbalagem(state, payload) {
      state.DataImages.AberturaEmbalagem = payload;
    },
    MutationImagesMoldeFechado(state, payload) {
      state.DataImages.MoldeFechado = payload;
    },
    MutationImagesMoldeAberto(state, payload) {
      state.DataImages.MoldeAberto = payload;
    },
    MutationImagesLSP(state, payload) {
      state.DataImagesLSP = payload;
    },
    MutationGetFindDataRRIM(state, payload) {
      state.DataAllRRIM = payload;
    },

    MutationSetDataChecklistUpdate(state, payload) {
      state.emitData.checklist = payload;
    },

    MutationSetDataProdutosUpdate(state, payload) {
      state.emitData.produtos = payload;
    },

    MutationSetSatatusNavBar(state, payload) {
      state.statusNavbar = payload;
    },
    MutationSetCancelModalEditRRIM(state, payload) {
      state.ModalCancel.rrimEdit = payload;
    },

    MutationSetCancelModalViewRRIM(state, payload) {
      state.ModalCancel.rrimView = payload;
    },

    MutationSetCancelModalLayoutExtra(state, payload) {
      state.ModalCancel.layout_extracao = payload;
    },

    MutationSetCancelModaItemCheckllist(state, payload) {
      state.ModalCancel.itemChecklist = payload;
    },
    SetUsers(state, payload) {
      state.user = payload.user;
    },
    SetListLayout(state, payload) {
      state.listLayout = [];
      state.listLayout = payload;
    },
    SetListItems(state, payload) {
      state.listItems = [];
      state.listItems = payload;
    },
    SetLoading(state, payload) {
      state.loading = payload;
    },

    SetLoadingPattern(state, payload) {
      state.loadingPattern = payload;
    },

    SetLoadingPatternProgress(state, payload) {
      state.loadingPatternProgress = payload;
    },
  },
  actions: {
    SetImagesAberturaEmbalagem(context, payload) {
      context.commit("MutationImagesAberturaEmbalagem", payload);
    },

    SetImagesMoldeAberto(context, payload) {
      context.commit("MutationImagesMoldeAberto", payload);
    },

    SetImagesMoldeFechado(context, payload) {
      context.commit("MutationImagesMoldeFechado", payload);
    },
    SetImagesLSP(context, payload) {
      context.commit("MutationImagesLSP", payload);
    },
  },
  getters: {
    $GetDataImages(state) {
      return state.DataImages;
    },
    $GetImagesLSP(state) {
      return state.DataImagesLSP;
    },
    async $GetDataAllRRIM(state) {
      return state.DataAllRRIM;
    },
    $GetDataEmitsUpdate(state) {
      return state.emitData;
    },
    $GetStatusNavBar(state) {
      return state.statusNavbar;
    },
    $GetModalCancel(state) {
      return state.ModalCancel;
    },

    get_users(state) {
      return state.user;
    },
  },
});

export { store };
